import React, { Suspense, lazy } from 'react';
import MathFallback from './MathFallback';

const MathRenderer = lazy(() => import('./MathRenderer'));

class MathBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

/** Load KaTeX only for answers with formulas; plain Markdown stays lightweight. */
export default React.memo(function MathText(props) {
  const fallback = <MathFallback {...props} />;
  return <MathBoundary fallback={fallback}><Suspense fallback={fallback}><MathRenderer {...props} /></Suspense></MathBoundary>;
});
